var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-burder",on:{"click":_vm.updateSidebarState}},[_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }